<template>
  <textarea
    class="textarea"
    :value="modelValue"
    @input="updateInput"
    @keydown="$emit('keydown', $event)"
  ></textarea>
</template>

<script type="text/javascript">
export default {
  name: "base-textarea",
  emits: ["update:modelValue", "keydown"],
  props: {
    modelValue: [String, Number],
  },
  methods: {
    updateInput(event) {
      this.$emit("update:modelValue", event.target.value);
    },
  },
};
</script>

<style scoped>
.textarea {
  padding: 10px 12px;
  width: 100%;
  min-height: 68px;
  max-height: 300px;
  border: 1px solid #999;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
}

.textarea:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.textarea::placeholder {
  opacity: 0.5;
}

.textarea:focus {
  outline: 1px solid var(--color-green);
}

.textarea.invalid {
  border-color: var(--color-danger);
}
</style>
